/* eslint-disable consistent-return */
import { Mongo } from 'meteor/mongo';
import SimpleSchema from 'simpl-schema';
import faker from 'faker';
import { includes, values, pick, map, isNil, get } from 'lodash';

import requiredIf from '../../modules/schema-conditional-required';
import { FeatureCollection, FeaturePoint } from '../SchemaUtilities/GeoJSONSchema';

export const FIWARE_VERSIONS = {
  V1: 'v1',
  V3: 'v3',
  properties: {
    V1: {
      name: 'V1',
      value: 'v1',
      humanValue: 'v1'
    },
    V3: {
      name: 'V3',
      value: 'v3',
      humanValue: 'v3'
    }
  }
};

export const PROP_DATA_TYPE = {
  NUMBER: 'number',
  STRING: 'string',
  NIL: 'nil',
  BOOL: 'bool'
};

export const GEOJSON_GEOMETRIES = {
  POINT: 'Point',
  LINESTRING: 'LineString',
  POLYGON: 'Polygon'
};

export const LAYER_TYPES = {
  TRIDIMENSIONAL: '3D',
  SPATIAL: 'spatial',
  THEMATIC: 'thematic',
  JOIN: 'join',
  properties: {
    TRIDIMENSIONAL: {
      name: '3D',
      value: '3D',
      humanValue: '3D Layer'
    },
    SPATIAL: {
      name: 'SPATIAL',
      value: 'spatial',
      humanValue: 'Spatial Layer'
    },
    THEMATIC: {
      name: 'THEMATIC',
      value: 'thematic',
      humanValue: 'Thematic Layer'
    },
    JOIN: {
      name: 'JOIN',
      value: 'join',
      humanValue: 'Join Layers'
    }
  }
};
export const LAYER_TYPES_FREE = {
  SPATIAL: 'spatial',
  THEMATIC: 'thematic',
  JOIN: 'join',
  properties: {
    SPATIAL: {
      name: 'SPATIAL',
      value: 'spatial',
      humanValue: 'Spatial Layer'
    }
  }
};

export const GEOREF_TYPES = {
  ADDRESS: 'address',
  H3: 'h3',
  LOCATION: 'location',
  LONGLAT: 'longLat',
  properties: {
    LOCATION: {
      name: 'LOCATION',
      value: 'location',
      humanValue: 'Location'
    },
    LONGLAT: {
      name: 'LONGLAT',
      value: 'longLat',
      humanValue: 'Longitude & latitude'
    },
    H3: {
      name: 'H3',
      value: 'h3',
      humanValue: 'H3'
    },
    ADDRESS: {
      name: 'ADDRESS',
      value: 'address',
      humanValue: 'Address'
    }
  }
};

export const LAYER_SUBTYPES = {
  ANNOTATIONS: 'annotations',
  ANNOTATIONSREALTIME: 'annotationsRealTime',
  CESIUM3DTILESET: 'cesium3Dtileset',
  CSV: 'csv',
  EXCEL: 'excel',
  EXTERNAL_SERVER: 'externalServer',
  FIWARE: 'fiware',
  GOOGLE_SHEETS: 'googlesheets',
  GEOIMAGE: 'GeoImage',
  GEOJSON: 'GeoJSON',
  GEOJSONVT: 'GeoJSONVT',
  GEOTIFF: 'GeoTIFF',
  INDOOR: 'indoor',
  INNERJOIN: 'inner-join',
  LEFTJOIN: 'left-join',
  MAPBOX: 'mapBox',
  MAPBOXGL: 'mapBoxGL',
  OGR: 'ogr',
  POSTGRESQL: 'postgreSQL',
  RIGHTJOIN: 'right-join',
  REALTIME: 'realTime',
  TILE_SERVER: 'tileServer',
  TOPOJSON: 'TopoJSON',
  TMS: 'TMS',
  UPLOADED_FILE: 'uploadedFile',
  WMTS: 'WMTS',
  WMS: 'WMS',
  properties: {
    ANNOTATIONS: {
      name: 'ANNOTATIONS',
      value: 'annotations',
      humanValue: 'Annotations'
    },
    ANNOTATIONSREALTIME: {
      name: 'ANNOTATIONSREALTIME',
      value: 'annotationsRealTime',
      humanValue: 'Annotations Real Time'
    },
    CESIUM3DTILESET: {
      name: 'CESIUM3DTILESET',
      value: 'cesium3Dtileset',
      humanValue: 'Cesium 3D Tileset'
    },
    CSV: {
      name: 'CSV',
      value: 'csv',
      humanValue: 'CSV'
    },
    EXCEL: {
      name: 'EXCEL',
      value: 'excel',
      humanValue: 'Excel'
    },
    EXTERNAL_SERVER: {
      name: 'EXTERNAL_SERVER',
      value: 'externalServer',
      humanValue: 'External Server'
    },
    FIWARE: {
      name: 'FIWARE',
      value: 'fiware',
      humanValue: 'Fiware'
    },
    GEOIMAGE: {
      name: 'GEOIMAGE',
      value: 'GeoImage',
      humanValue: 'GeoImage'
    },
    GEOJSON: {
      name: 'GEOJSON',
      value: 'GeoJSON',
      humanValue: 'GeoJSON'
    },
    GEOJSONVT: {
      name: 'GEOJSONVT',
      value: 'GeoJSONVT',
      humanValue: 'GeoJSON VT'
    },
    GEOTIFF: {
      name: 'GEOTIFF',
      value: 'GeoTIFF',
      humanValue: 'GeoTIFF'
    },
    GOOGLE_SHEETS: {
      name: 'GOOGLE_SHEETS',
      value: 'googlesheets',
      humanValue: 'Google Sheets'
    },
    INDOOR: {
      name: 'INDOOR',
      value: 'indoor',
      humanValue: 'Indoor GeoJSON'
    },
    INNERJOIN: {
      name: 'INNERJOIN',
      value: 'inner-join',
      humanValue: 'Inner Join'
    },
    LEFTJOIN: {
      name: 'LEFTJOIN',
      value: 'left-join',
      humanValue: 'Left Join'
    },
    MAPBOX: {
      name: 'MAPBOX',
      value: 'mapBox',
      humanValue: 'MapBox'
    },
    MAPBOXGL: {
      name: 'MAPBOXGL',
      value: 'mapBoxGL',
      humanValue: 'MapBox GL'
    },
    OGR: {
      name: 'OGR',
      value: 'ogr',
      humanValue: 'OGR'
    },
    POSTGRESQL: {
      name: 'POSTGRESQL',
      value: 'postgreSQL',
      humanValue: 'PostgreSQL'
    },
    REALTIME: {
      name: 'REALTIME',
      value: 'realTime',
      humanValue: 'Real Time GeoJSON'
    },
    RIGHTJOIN: {
      name: 'RIGHTJOIN',
      value: 'right-join',
      humanValue: 'Right Join'
    },
    TMS: {
      name: 'TMS',
      value: 'TMS',
      humanValue: 'TMS'
    },
    TOPOJSON: {
      name: 'TOPOJSON',
      value: 'TopoJSON',
      humanValue: 'TopoJSON'
    },
    UPLOADED_FILE: {
      name: 'UPLOADED_FILE',
      value: 'uploadedFile',
      humanValue: 'Upload File'
    },
    WMS: {
      name: 'WMS',
      value: 'WMS',
      humanValue: 'WMS'
    },
    WMTS: {
      name: 'WMTS',
      value: 'WMTS',
      humanValue: 'WMTS'
    },
    TILE_SERVER: {
      name: 'TILE_SERVER',
      value: 'tileServer',
      humanValue: 'xyzTiles'
    }
  }
};

export const SPATIAL_SUBTYPES = pick(LAYER_SUBTYPES, [
  'ANNOTATIONS',
  'ANNOTATIONSREALTIME',
  'CSV',
  'EXCEL',
  'EXTERNAL_SERVER',
  'FIWARE',
  'GOOGLE_SHEETS',
  'GEOIMAGE',
  'GEOJSON',
  'GEOJSONVT',
  'GEOTIFF',
  'INDOOR',
  'MAPBOX',
  'MAPBOXGL',
  'OGR',
  'POSTGRESQL',
  'REALTIME',
  'TILE_SERVER',
  'TMS',
  'TOPOJSON',
  'UPLOADED_FILE',
  'WMTS',
  'WMS'
]);
export const TRIDIMENSIONAL_SUBTYPES = pick(LAYER_SUBTYPES, ['CESIUM3DTILESET']);
export const FREE_SUBTYPES = pick(LAYER_SUBTYPES, ['GEOJSON', 'TILE_SERVER', 'WMS']);

export const THEMATIC_SUBTYPES = pick(LAYER_SUBTYPES, [
  'CSV',
  'EXCEL',
  'EXTERNAL_SERVER',
  'FIWARE',
  'GOOGLE_SHEETS',
  'POSTGRESQL',
  'UPLOADED_FILE'
]);

export const JOIN_SUBTYPES = pick(LAYER_SUBTYPES, ['INNERJOIN', 'LEFTJOIN', 'RIGHTJOIN']);

export const RASTER_3D_MAPS_SUBTYPES = values(
  pick(LAYER_SUBTYPES, ['TILE_SERVER', 'TMS', 'WMS', 'WMTS', 'CESIUM3DTILESET'])
);

export const SPATIAL_FOR_JOIN_SUBTYPES = values(
  pick(LAYER_SUBTYPES, [
    'ANNOTATIONSREALTIME',
    'CSV',
    'EXCEL',
    'FIWARE',
    'GEOJSON',
    'GEOJSONVT',
    'GOOGLE_SHEETS',
    'OGR',
    'POSTGRESQL',
    'REALTIME',
    'TOPOJSON'
  ])
);

export const GEOJSON_API_BASED_SUBTYPES = values(
  pick(LAYER_SUBTYPES, [
    'ANNOTATIONS',
    'CSV',
    'EXCEL',
    'FIWARE',
    'GEOJSON',
    'GOOGLE_SHEETS',
    'INNERJOIN',
    'LEFTJOIN',
    'OGR',
    'POSTGRESQL',
    'RIGHTJOIN'
  ])
);

export const URL_REQUIRING_SUBTYPES = values(
  pick(LAYER_SUBTYPES, [
    'CESIUM3DTILESET',
    'CSV',
    'EXCEL',
    'FIWARE',
    'GEOIMAGE',
    'GEOJSON',
    'GEOJSONVT',
    'GOOGLE_SHEETS',
    'INDOOR',
    'MAPBOX',
    'MAPBOXGL',
    'OGR',
    'REALTIME',
    'TILE_SERVER',
    'TOPOJSON',
    'GEOTIFF',
    'TMS',
    'WMS',
    'WMTS'
  ])
);

export const WMS_VERSIONS = {
  V130: '1.3.0',
  V111: '1.1.1',
  V110: '1.1.0',
  V100: '1.0.0',
  properties: {
    V130: {
      name: 'V130',
      value: '1.3.0',
      humanValue: '1.3.0'
    },
    V111: {
      name: 'V111',
      value: '1.1.1',
      humanValue: '1.1.1'
    },
    V110: {
      name: 'V110',
      value: '1.1.0',
      humanValue: '1.1.0'
    },
    V100: {
      name: 'V100',
      value: '1.0.0',
      humanValue: '1.0.0'
    }
  }
};

/**
 * Get the subtypes allowed for each layer type.
 *
 * @param {string} layerType - The layer type.
 * @param {string} [resultFormat=array] - The format for the layer subtypes.
 * @param {boolean}  isFree - The user role is Free.
 * @returns {string[]|object} The layer subtypes allowed for each type.
 * If resultFormat is array or anything else, returns an array of the string values.
 * If resultFormat is object, returns an key value object.
 */
export const getSubTypesForType = (layerType, resultFormat = 'array', isFree) => {
  if (isFree) {
    return FREE_SUBTYPES;
  }
  if (resultFormat === 'object') {
    switch (layerType) {
      case LAYER_TYPES.TRIDIMENSIONAL:
        return TRIDIMENSIONAL_SUBTYPES;
      case LAYER_TYPES.SPATIAL:
        return SPATIAL_SUBTYPES;
      case LAYER_TYPES.THEMATIC:
        return THEMATIC_SUBTYPES;
      case LAYER_TYPES.JOIN:
        return JOIN_SUBTYPES;
      default:
        return {};
    }
  }
  switch (layerType) {
    case LAYER_TYPES.TRIDIMENSIONAL:
      return values(TRIDIMENSIONAL_SUBTYPES);
    case LAYER_TYPES.SPATIAL:
      return values(SPATIAL_SUBTYPES);
    case LAYER_TYPES.THEMATIC:
      return values(THEMATIC_SUBTYPES);
    case LAYER_TYPES.JOIN:
      return values(JOIN_SUBTYPES);
    default:
      return [];
  }
};

const Layers = new Mongo.Collection('Layers');

Layers.allow({
  insert: () => false,
  update: () => false,
  remove: () => false
});

Layers.deny({
  insert: () => true,
  update: () => true,
  remove: () => true
});

/**
 * The connection params for PostgreSQL layers (needed in PostgreSQL).
 *
 * @typedef {object} connectionParams
 * @property {string} database - The name of the database for the connection.
 * @property {string} host - The ip adress for the connection.
 * @property {string} password - The password for the connection.
 * @property {number} port - The port number for the connection.
 * @property {string} schema - The name of the schema for the connection.
 * @property {string} table - The name of the table for the connection.
 * @property {string} user - The user for the connection.
 */
const connectionParamsSchema = new SimpleSchema({
  database: {
    type: String,
    label: 'The name of the database for the connection'
  },
  host: {
    type: String,
    label: 'The hostfor the connection'
  },
  password: {
    type: String,
    label: 'The password for the connection'
  },
  port: {
    type: Number,
    label: 'The port number for the connection'
  },
  schema: {
    type: String,
    label: 'The name of the schema for the connection'
  },
  table: {
    type: String,
    label: 'The name of the table for the connection'
  },
  user: {
    type: String,
    label: 'The user for the connection'
  }
});

/**
 * The limits for the rows and colummns in a Excel (needed in Excel).
 *
 * @typedef {object} excelLimits
 * @property {string[]} columns - The names of the selected columns.
 * @property {number} firstColumn - The number of the first column.
 * @property {number} firstRow - The number of the first row.
 * @property {number} lastColumn - The number of the last column.
 * @property {number} lastRow - The number of the last row.
 */
const excelLimitsSchema = new SimpleSchema({
  columns: {
    type: Array,
    label: 'The name of the selected columns',
    optional: true
  },
  'columns.$': {
    type: String,
    label: 'The name of each selected column'
  },
  firstColumn: {
    type: Number,
    label: 'The number of the first column',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: LAYER_SUBTYPES.EXCEL === this.field('layerSubType').value,
        schemaInstance: this
      });
    }
  },
  firstRow: {
    type: Number,
    label: 'The number of the first row'
  },
  lastColumn: {
    type: Number,
    label: 'The number of the last column',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: LAYER_SUBTYPES.EXCEL === this.field('layerSubType').value,
        schemaInstance: this
      });
    }
  },
  lastRow: {
    type: Number,
    label: 'The number of the last row'
  }
});

/**
 * The connection params for Fiware layers (needed in Fiware).
 *
 * @typedef {object} fiwareParams
 * @property {string} fiwareApplicationID - The key of a codify ID.
 * @property {string} fiwareApplicationSecret - The key of a secret codify user.
 * @property {string} fiwareURL - The url for the connection.
 * @property {string} fiwareVersion - The version of the service for the connection.
 * @property {string} host - The ip adress for the connection.
 * @property {string} password - The password for the connection.
 * @property {number} port - The port number for the connection.
 * @property {string} service - The name of the service for the connection.
 * @property {string} subservice - The name of the subservice for the connection.
 * @property {string} user - The user for the connection.
 */
const fiwareParamsSchema = new SimpleSchema({
  fiwareApplicationID: {
    type: String,
    label: 'The key of a codify ID',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('fiwareVersion').value === FIWARE_VERSIONS.V1,
        schemaInstance: this
      });
    }
  },
  fiwareApplicationSecret: {
    type: String,
    label: 'The key of a secret codify user',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('fiwareVersion').value === FIWARE_VERSIONS.V1,
        schemaInstance: this
      });
    }
  },
  fiwareURL: {
    type: String,
    label: 'The url for the connection'
  },
  fiwareVersion: {
    type: String,
    label: 'The version of the service for the connection',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.FIWARE,
        schemaInstance: this
      });
    }
  },
  host: {
    type: String,
    label: 'The hostfor the connection'
  },
  password: {
    type: String,
    label: 'The password for the connection'
  },
  port: {
    type: Number,
    label: 'The port number for the connection'
  },
  service: {
    type: String,
    label: 'The name of the service for the connection'
  },
  subservice: {
    type: String,
    label: 'The name of the subservice for the connection'
  },
  user: {
    type: String,
    label: 'The user for the connection'
  }
});

/**
 * An object containing longitude, latitude and, optionally, altitude.
 *
 * @typedef {object} latLng
 * @property {number} [alt] - Altitude in meters (optional).
 * @property {number} lat - Latitude in degrees.
 * @property {number} lng - Longitude in degrees.
 */
const latLng = new SimpleSchema({
  alt: {
    type: Number,
    label: 'Altitude in meters',
    optional: true
  },
  lat: {
    type: Number,
    label: 'Latitude in degrees'
  },
  lng: {
    type: Number,
    label: 'Longitude in degrees'
  }
});

/**
 * The object that contains the coordinates of the corners of the image (needed in GeoImage).
 *
 * @typedef {object} geoImageCorners
 * @property {latLng} bottomLeft - The image bottom left corner coordinates.
 * @property {latLng} topLeft - The image top left corner coordinates.
 * @property {latLng} topRight - The image top right corner coordinates.
 */
const geoImageCorners = new SimpleSchema({
  bottomLeft: {
    type: latLng,
    label: 'The image bottom left corner coordinates'
  },
  topLeft: {
    type: latLng,
    label: 'The image top left corner coordinates'
  },
  topRight: {
    type: latLng,
    label: 'The image top right corner coordinates'
  }
});

/**
 * The properties available in a geojson layer (needed in geojson).
 *
 * @typedef {object} geojsonProp
 * @property {string} dataType - The data type for the property. One of [string, number, nil]:
 * 1) number - at least one value is a number
 * 2) nil - every value is null or undefined
 * 3) string - everything else.
 * @property {string|number|boolean} max - The maximum value for the property.
 * @property {string|number|boolean} min - The minimum value for the property.
 * @property {string} name - The name of the property.
 */
const propertyDataSchema = new SimpleSchema({
  dataType: {
    type: String,
    label: 'The data type for this property. Should be string or number',
    allowedValues: values(PROP_DATA_TYPE)
  },
  max: {
    type: SimpleSchema.oneOf(String, Number, Boolean),
    optional: true,
    // FIXME: si el minimo es un string vacio me da error al guardar
    label: 'The max value for the property in the geojson and topojson'
  },
  min: {
    type: SimpleSchema.oneOf(String, Number, Boolean),
    optional: true,
    // FIXME: si el minimo es un string vacio me da error al guardar
    label: 'The min value for the property in the geojson and topojson'
  },
  name: {
    type: String,
    label: 'The name of the property in the Feature'
  }
});

/**
 * The fields that contains the longitude and latitude (needed in Spatial CSV).
 *
 * @typedef {object} spatialTableFields
 * @property {string} latitude - The key that contains the latitude.
 * @property {string} longitude - The key that contains the longitude.
 */
const spatialTableFields = new SimpleSchema({
  latitude: {
    type: String,
    label: 'The key that contains the latitude'
  },
  longitude: {
    type: String,
    label: 'The key that contains the longitude'
  }
});

/**
 * The fields that contains the key and name of the geometry in annotation layer.
 *
 * @typedef {object} spatialTableFields
 * @property {string} key - The name to show.
 * @property {string} name - The key of the geometry.
 */
const annotationLayerGeometryDataSchema = new SimpleSchema({
  key: {
    type: String,
    label: 'Flag that checks if each component is shown'
  },
  name: {
    type: String,
    label: 'The name to show the component'
  }
});

/**
 * The fields that contains the longitude and latitude (needed in Spatial CSV).
 *
 * @typedef {object} annotationLayerPropertiesSchema
 * @property {Array} annotationsId - The annotations.
 * @property {object} geometry - The type of geometry of the video and the layer.
 * @property {object} geojsonAnnotations - The geojson to draw on map.
 * @property {object} projectId - The project.
 * @property {Array} videosId -The list of all videos belonging to the project.

 */
const annotationLayerPropertiesSchema = new SimpleSchema({
  annotationsId: {
    type: Array,
    label: 'The list of annotations from the videos selected',
    optional: true
  },
  'annotationsId.$': {
    type: String,
    label: 'The list of id annotations from the videos selected',
    optional: true
  },
  geometry: {
    type: annotationLayerGeometryDataSchema,
    label: 'The geometry of the layer',
    optional: true
  },
  geojsonAnnotations: {
    type: FeatureCollection,
    label: 'The geojson to draw on the map',
    optional: true
  },
  projectId: {
    type: String,
    label: 'The proyect selected'
  },
  videosId: {
    type: Array,
    label: 'The list of videos from the proyect selected',
    optional: true
  },
  'videosId.$': {
    type: String,
    label: 'The list of id videos from the proyect selected',
    optional: true
  }
});

/**
 * A layer object for ipsilum maps.
 *
 * @typedef {object} Layer
 * @property {string} _id - The layer id.
 * @property {string} createdAt - The date when it was created.
 * @property {string} deleted - Indicates whether the layer is in the trash or not.
 * @property {string} [description] - The description for the layer.
 * @property {string} layerSubType - The layer subtype. For each type, different subtypes:
 * FIXME: Some of these may get deprecated
 * spatial - [ annotations, tileServer, TMS, WMS, WMTS, GeoImage, GeoTIFF, mapBoxGL, GeoJSON, GeoJSONVT, mapBox, ogr, realTime, TopoJSON, csv, excel, externalServer, googlesheets, postgreSQL, fiware, uploadedFile]
 * thematic - [csv, excel, externalServer, googlesheets, postgreSQL, fiware, uploadedFile]
 * join - [inner-join, left-join, right-join].
 * @property {string} layerType - The layer type. One of [spatial, thematic, join].
 * @property {string} name - The name for the layer.
 * @property {string} owner - The owner id.
 * @property {string} publicDataId - The public key generated for the URL.
 * @property {boolean} sharedData - Indicates whether it is being shared or not.
 * @property {boolean} sharedPrivateData - Indicates whether it is being shared or not.
 * @property {string} updatedAt - The date when it was last updated.
 * @property {string} [accessToken] - Token to access the MapBox GL style (needed in mapBoxGL).
 * @property {string} [addressIndex] - The name of the attribute to use as address index (needed in spatial fiware if address georeferencing).
 * @property {string} [attribution] - Attribution to be used in tile layer providers (needed in spatial).
 * @property {connectionParams} [connectionParams] - The connection parameters for PostgreSQL layers (needed in postgreSQL).
 * @property {excelLimits} [excelLimits] - The limits for the rows and colummns in a Excel (needed in excel, googlesheets).
 * @property {string} [excelSheet] - The name of the sheet of the xlsx (needed in excel, googlesheets).
 * @property {string} [fiwareLayerName] - The name of the Fiware layer (needed in fiware).
 * @property {fiwareParams} [fiwareParams] - The connection parameters for fiware layers (needed in fiware).
 * @property {geoImageCorners} [geoImageCorners] - The coordinates of the GeoImage corners (needed in GeoImage).
 * @property {string} [geojsonGeometry] - The geometry defined for the layer (needed in GeoJSON, GeoJSONVT, mapBox, ogr, realTime, TopoJSON, spatial csv, excel, googlesheets, postgreSQL, fiware, join).
 * @property {annotationLayerPropertiesSchema} annotationLayerProperties - The map center for the layer.
 * @property {string} [geojsonId] - The id of the geojson layer used on the join (needed in join).
 * @property {geojsonProp[]} [geojsonProps] - The properties available in a geojson layer (needed in GeoJSON, GeoJSONVT, mapBox, ogr, realTime, TopoJSON, spatial csv, excel, googlesheets, postgreSQL, fiware, join).
 * @property {string} [geojsonPropToJoin] - The name of the prop used for the join (needed in join).
 * @property {string} [georefType] - The type of georeferencing (needed in spatial csv, excel, fiware, googlesheets). One of [location, longLat, h3, address].
 * @property {number} [geoTiffResolution] - The resolution of the GeoTIFF image (needed in geoTiff).
 * @property {string} [h3Index] - The name of the attribute to use as H3 index (needed in spatial csv, excel, googlesheets if h3 georeferencing).
 * @property {string} [imageFormat] - The name of the selected WMTS format (needed in WMTS).
 * @property {string} [imageUrl] - The url for the image thumbnail.
 * @property {number} [indoorLevel] - The name of the attribute to use as Indoor level (needed in indoor).
 * @property {number} [interval] - The time interval for refreshing the Real Time Layers in milliseconds (needed in realTime).
 * @property {string} [layerNames] - The names of the layers to show in the wms layer as codes to enter in Leaflet (needed in WMS).
 * @property {string} [layerTitles] - The names of the layers to show in the wms layer in a human readable format (needed in WMS).
 * @property {string} [locationIndex] - The name of the attribute to use as location index (needed in spatial fiware if location georeferencing).
 * @property {string} [mapboxLayerName] - The name of the layer to draw (needed in mapBox).
 * @property {geojsonProp[]} [mapboxProps] - The properties available in a MapBox layer (needed in mapBox).
 * @property {FeaturePoint} [mapLocation] - The map center for the layer.
 * @property {string} [ogrAttributes] - The name of the attributes, separated by commas, to fetch in OGR Layers (needed in OGR).
 * @property {string} [ogrLayerName] - The name of the layer to fetch in OGR Layers (needed in ogr).
 * @property {string} [separator] - The separator in a CSV Layer (needed in csv).
 * @property {number} [sorensenDiceMinimun] - The minimun value for the Sorensen-Dice to join (needed in join).
 * @property {spatialTableFields} [spatialTableFields] - The fields that contains the longitude and latitude (needed in spatial csv, excel, fiware, googlesheets if longLat georeferencing).
 * @property {string} [styleId] - The id for the style used on this layer (needed in spatial).
 * @property {string} [styleName] - The name of the selected WMS style.
 * @property {string} [subdomains] - Subdomains to be used in tile layer providers (needed in tileServer).
 * @property {string} [thematicId] - The id of the thematic layer used on the join (needed in join).
 * @property {Array} [thematicKeyList] - The list of keys found in the thematic file (needed in thematic).
 * @property {string} [thematicKeyToJoin] - The name of the key used for the join (needed in join).
 * @property {string} [tileMatrixSet] - The name of the selected WMTS tile matrix set (needed in WMTS).
 * @property {string} [url] - The layer url (needed in tileServer, TMS, WMS, WMTS, GeoImage, GeoTIFF, mapBoxGL, GeoJSON, GeoJSONVT, mapBox, ogr, realTime, TopoJSON, csv, excel, googlesheets).
 * @property {string} [wmsVersion] - The version to show the WMS layer (needed in WMS).
 * @property {string} [wmtsLayer] - The name of the selected WMTS layer (needed in WMTS).
 * @property {string} [wmtsStyle] - The name of the selected WMTS style (needed in WMTS).
 * @property {number} [maxZoom] - The maximum number of possible zoom in a layer.
 * @property {number} [minZoom] - The minimum number of possible zoom in a layer.
 */
Layers.schema = new SimpleSchema({
  annotationLayerProperties: {
    type: annotationLayerPropertiesSchema,
    label: 'annotationLayerProperties',
    optional: true
  },
  createdAt: {
    type: String,
    label: 'The date this layer was created in the database',
    autoValue() {
      if (this.isInsert) return new Date().toISOString();
    }
  },
  deleted: {
    type: String,
    label: 'The date the layer was deleted',
    autoValue() {
      if (this.isInsert) return 'no';
    }
  },
  description: {
    type: String,
    label: 'A description of the layer',
    optional: true
  },
  layerSubType: {
    type: String,
    label: 'The type of the layer added',
    optional: true,
    custom() {
      const shouldBeRequired = includes(
        [LAYER_TYPES.SPATIAL, LAYER_TYPES.THEMATIC, LAYER_TYPES.JOIN],
        this.field('layerType').value
      );

      if (shouldBeRequired) {
        // inserts
        if (!this.operator) {
          if (!this.isSet || this.value === null || this.value === '')
            return SimpleSchema.ErrorTypes.REQUIRED;
        }

        // updates
        else if (this.isSet) {
          if (this.operator === '$set' && (this.value === null || this.value === ''))
            return SimpleSchema.ErrorTypes.REQUIRED;
          if (this.operator === '$unset') return SimpleSchema.ErrorTypes.REQUIRED;
          if (this.operator === '$rename') return SimpleSchema.ErrorTypes.REQUIRED;
        }
        const allowedValues = getSubTypesForType(this.field('layerType').value);

        if (!includes(allowedValues, this.value)) {
          return SimpleSchema.ErrorTypes.VALUE_NOT_ALLOWED;
        }
      }
    }
  },
  layerType: {
    type: String,
    label: 'The type of the layer added',
    allowedValues: map(LAYER_TYPES.properties, 'value')
  },
  name: {
    type: String,
    label: 'A name to identify the layer'
  },
  owner: {
    type: String,
    label: 'The ID of the user this layer belongs to'
  },
  publicDataId: {
    type: String,
    label: 'The public key generated for the URL',
    optional: true,
    autoValue() {
      const publicDataId = get(Layers.findOne(this.docId), 'publicDataId');
      if (this.isInsert || (this.isUpdate && isNil(publicDataId))) return faker.internet.password();
    }
  },
  sharedData: {
    type: Boolean,
    label: 'Flag that checks if layer is shared',
    autoValue() {
      if (this.isInsert) return false;
    }
  },
  sharedPrivateData: {
    type: Boolean,
    label: 'Flag that checks if map is shared Private',
    autoValue() {
      if (this.isInsert) return false;
    }
  },
  updatedAt: {
    type: String,
    label: 'The date this layer was last updated',
    autoValue() {
      if (this.isInsert || this.isUpdate) return new Date().toISOString();
    }
  },
  accessToken: {
    type: String,
    label: 'Token to access the MapBox GL style',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.MAPBOXGL,
        schemaInstance: this
      });
    }
  },
  addressIndex: {
    type: String,
    label: 'The name of the attribute to use address index',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          includes([LAYER_SUBTYPES.FIWARE], this.field('layerSubType').value) &&
          this.field('layerType').value === LAYER_TYPES.SPATIAL &&
          this.field('georefType').value === GEOREF_TYPES.ADDRESS,
        schemaInstance: this
      });
    }
  },
  attribution: {
    type: String,
    label: 'Attribution to be used in tile layer providers',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.SPATIAL,
        schemaInstance: this
      });
    }
  },
  connectionParams: {
    type: connectionParamsSchema,
    label: 'The connection parameters',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.POSTGRESQL,
        schemaInstance: this
      });
    }
  },
  excelLimits: {
    type: excelLimitsSchema,
    label: 'The limits for the rows and colummns in a Excel',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: includes(
          [LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS],
          this.field('layerSubType').value
        ),
        schemaInstance: this
      });
    }
  },
  excelSheet: {
    type: String,
    label: 'The name of the sheet of the xlsx',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: includes(
          [LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS],
          this.field('layerSubType').value
        ),
        schemaInstance: this
      });
    }
  },
  fiwareLayerName: {
    type: String,
    label: 'The type of georeferencing for the Fiware layer',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.FIWARE,
        schemaInstance: this
      });
    }
  },
  fiwareParams: {
    type: fiwareParamsSchema,
    label: 'The Fiware parameters',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.FIWARE,
        schemaInstance: this
      });
    }
  },
  geoImageCorners: {
    type: geoImageCorners,
    label: 'The coordinates of the GeoImage corners',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.GEOIMAGE,
        schemaInstance: this
      });
    }
  },
  geojsonGeometry: {
    type: String,
    label: 'The geometry of the geojson',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          this.field('layerType').value === LAYER_TYPES.JOIN ||
          (this.field('layerType').value === LAYER_TYPES.SPATIAL &&
            includes(
              [
                LAYER_SUBTYPES.ANNOTATIONS,
                LAYER_SUBTYPES.CSV,
                LAYER_SUBTYPES.EXCEL,
                LAYER_SUBTYPES.FIWARE,
                LAYER_SUBTYPES.GEOJSON,
                LAYER_SUBTYPES.GEOJSONVT,
                LAYER_SUBTYPES.GOOGLE_SHEETS,
                LAYER_SUBTYPES.INDOOR,
                LAYER_SUBTYPES.MAPBOX,
                LAYER_SUBTYPES.OGR,
                LAYER_SUBTYPES.POSTGRESQL,
                LAYER_SUBTYPES.REALTIME,
                LAYER_SUBTYPES.ANNOTATIONSREALTIME,
                LAYER_SUBTYPES.TOPOJSON
              ],
              this.field('layerSubType').value
            )),
        schemaInstance: this
      });
    }
  },
  geojsonId: {
    type: String,
    label: 'The id of the spatial layer used in the join',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.JOIN,
        schemaInstance: this
      });
    }
  },
  geojsonProps: {
    type: Array,
    label: 'The properties of the GeoJSON that can be used in the style',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          this.field('layerType').value === LAYER_TYPES.JOIN ||
          (this.field('layerType').value === LAYER_TYPES.SPATIAL &&
            includes(
              [
                LAYER_SUBTYPES.CSV,
                LAYER_SUBTYPES.EXCEL,
                LAYER_SUBTYPES.FIWARE,
                LAYER_SUBTYPES.GEOJSON,
                LAYER_SUBTYPES.GEOJSONVT,
                LAYER_SUBTYPES.GOOGLE_SHEETS,
                LAYER_SUBTYPES.INDOOR,
                LAYER_SUBTYPES.OGR,
                LAYER_SUBTYPES.POSTGRESQL,
                LAYER_SUBTYPES.REALTIME,
                LAYER_SUBTYPES.TOPOJSON
              ],
              this.field('layerSubType').value
            )),
        schemaInstance: this
      });
    }
  },
  'geojsonProps.$': {
    type: propertyDataSchema,
    label: 'A single property in the GeoJSON and TopoJSON'
  },
  geojsonPropToJoin: {
    type: String,
    label: 'The name of the prop used for the join',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.JOIN,
        schemaInstance: this
      });
    }
  },
  georefType: {
    type: String,
    label: 'The type of georeferencing for the thematic-based spatial layer',
    allowedValues: map(GEOREF_TYPES.properties, 'value'),
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          includes(
            [
              LAYER_SUBTYPES.CSV,
              LAYER_SUBTYPES.EXCEL,
              LAYER_SUBTYPES.FIWARE,
              LAYER_SUBTYPES.GOOGLE_SHEETS
            ],
            this.field('layerSubType').value
          ) && this.field('layerType').value === LAYER_TYPES.SPATIAL,
        schemaInstance: this
      });
    }
  },
  geoTiffResolution: {
    type: Number,
    label: 'The resolution of the GeoTIFF image',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.GEOTIFF,
        schemaInstance: this
      });
    }
  },
  h3Index: {
    type: String,
    label: 'The name of the attribute to use as H3 index',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          includes(
            [LAYER_SUBTYPES.CSV, LAYER_SUBTYPES.EXCEL, LAYER_SUBTYPES.GOOGLE_SHEETS],
            this.field('layerSubType').value
          ) &&
          this.field('layerType').value === LAYER_TYPES.SPATIAL &&
          this.field('georefType').value === GEOREF_TYPES.H3,
        schemaInstance: this
      });
    }
  },
  imageFormat: {
    type: String,
    optional: true,
    label: 'The name of the selected WMTS format',
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMTS,
        schemaInstance: this
      });
    }
  },
  imageUrl: {
    type: String,
    label: 'The url of an image to use as thumbnail',
    optional: true
  },
  indoorLevel: {
    type: String,
    label: 'The name of the attribute to use as Indoor level',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: LAYER_SUBTYPES.INDOOR === this.field('layerSubType').value,
        schemaInstance: this
      });
    }
  },
  interval: {
    type: Number,
    label: 'The time for refreshing the layer in milliseconds',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          this.field('layerSubType').value === LAYER_SUBTYPES.REALTIME ||
          this.field('layerSubType').value === LAYER_SUBTYPES.ANNOTATIONSREALTIME,
        schemaInstance: this
      });
    }
  },
  layerNames: {
    type: String,
    label: 'The names of the layers to select in a WMS as codes to enter in Leaflet',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMS,
        schemaInstance: this
      });
    }
  },
  layerTitles: {
    type: String,
    label: 'The names of the layers to select in a WMS in a human readable format',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMS,
        schemaInstance: this
      });
    }
  },
  locationIndex: {
    type: String,
    label: 'The name of the attribute to use as location index',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          includes([LAYER_SUBTYPES.FIWARE], this.field('layerSubType').value) &&
          this.field('layerType').value === LAYER_TYPES.SPATIAL &&
          this.field('georefType').value === GEOREF_TYPES.LOCATION,
        schemaInstance: this
      });
    }
  },
  mapboxLayerName: {
    type: String,
    label: 'The name of the layer to draw',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.MAPBOX,
        schemaInstance: this
      });
    }
  },
  mapboxProps: {
    type: Array,
    label: 'The name of the property to draw',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.MAPBOX,
        schemaInstance: this
      });
    }
  },
  'mapboxProps.$': {
    type: propertyDataSchema,
    label: 'A single property in the MapBox'
  },
  mapLocation: {
    type: FeaturePoint,
    label: 'The location of the project for the map. With the Bounding Box',
    optional: true
  },
  isFeature: {
    type: Boolean,
    label: 'The layer is from a Feature',
    optional: true
  },
  maxZoom: {
    type: Number,
    label: 'The maximum number of possible zoom in a layer.',
    optional: true
  },
  minZoom: {
    type: Number,
    label: 'The minimum number of possible zoom in a layer.',
    optional: true
  },
  ogrAttributes: {
    type: String,
    label: 'The name of the attributes to fetch in OGR Layers',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.OGR,
        schemaInstance: this
      });
    }
  },
  ogrLayerName: {
    type: String,
    label: 'The name of the layer to fetch in OGR Layers',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.OGR,
        schemaInstance: this
      });
    }
  },
  separator: {
    type: String,
    label: 'The separator on a CSV Layer',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.CSV,
        schemaInstance: this
      });
    }
  },
  ShowAnnotations: {
    type: Boolean,
    label: 'Flag that checks if it has to show the annotations marker',
    optional: true
  },
  ShowTraceVideo: {
    type: Boolean,
    label: 'Flag that checks if it has to show the trace if the video',
    optional: true
  },
  sorensenDiceMinimun: {
    type: Number,
    label: 'The minimun value for the Sorensen-Dice to join',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.JOIN,
        schemaInstance: this
      });
    }
  },
  spatialTableFields: {
    type: spatialTableFields,
    label: 'The keys that contain the longitude and latitude for the Spatial Table layers',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition:
          includes(
            [
              LAYER_SUBTYPES.CSV,
              LAYER_SUBTYPES.EXCEL,
              LAYER_SUBTYPES.FIWARE,
              LAYER_SUBTYPES.GOOGLE_SHEETS
            ],
            this.field('layerSubType').value
          ) &&
          this.field('layerType').value === LAYER_TYPES.SPATIAL &&
          this.field('georefType').value === GEOREF_TYPES.LONGLAT,
        schemaInstance: this
      });
    }
  },
  styleId: {
    type: String,
    label: 'The Id of the style used for this layer',
    optional: true
  },
  styleName: {
    type: String,
    label: 'The name of the selected WMS style',
    optional: true
  },
  subdomains: {
    type: String,
    label: 'Subdomains to be used in tile layer providers',
    optional: true
  },
  thematicId: {
    type: String,
    label: 'The id of the thematic layer used on the join (needed in join)',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.JOIN,
        schemaInstance: this
      });
    }
  },
  thematicKeyList: {
    type: Array,
    label: 'The list of keys found in the thematic file (needed in thematic)',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.THEMATIC,
        schemaInstance: this
      });
    }
  },
  'thematicKeyList.$': {
    type: String,
    label: 'A key found in the thematic file (needed in thematic)'
  },
  thematicKeyToJoin: {
    type: String,
    label: 'The name of the key used for the join (needed in join)',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerType').value === LAYER_TYPES.JOIN,
        schemaInstance: this
      });
    }
  },
  tileMatrixSet: {
    type: String,
    optional: true,
    label: 'The name of the selected WMTS tile matrix set',
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMTS,
        schemaInstance: this
      });
    }
  },
  url: {
    type: String,
    label: 'The url that points to the layer in question in an external server',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: includes(URL_REQUIRING_SUBTYPES, this.field('layerSubType').value),
        schemaInstance: this
      });
    }
  },
  wmsVersion: {
    type: String,
    label: 'The version to show the WMS layer',
    optional: true,
    allowedValues: map(WMS_VERSIONS.properties, 'value'),
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMS,
        schemaInstance: this
      });
    }
  },
  wmtsLayer: {
    type: String,
    label: 'The name of the selected WMTS layer',
    optional: true,
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMTS,
        schemaInstance: this
      });
    }
  },
  wmtsStyle: {
    type: String,
    optional: true,
    label: 'The name of the selected WMTS style',
    custom() {
      return requiredIf({
        requiredCondition: this.field('layerSubType').value === LAYER_SUBTYPES.WMTS,
        schemaInstance: this
      });
    }
  }
});

Layers.attachSchema(Layers.schema);

export default Layers;
